import * as React from 'react';
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, ChartData, ChartOptions, Legend, Tooltip, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { ChartRefContext } from "../context/ChartRefs";

ChartJS.register(BarElement, CategoryScale, LinearScale, Legend, Tooltip);


export type BarChartProps = {
    data: ChartData;
    options: ChartOptions;
    label: string;
}

export const BarChart = (props: BarChartProps): JSX.Element => {
    const [, dispatch] = React.useContext(ChartRefContext);
    const chartRef = React.createRef<ChartJS<'bar'>>();

    React.useEffect(() => {

        ChartJS.defaults.font.family = "AvenirBook";
        ChartJS.defaults.font.size = 14;

        dispatch({
            type: 'ADDCHARTREF', payload: {
                chartref: {
                    ref: chartRef.current,
                    label: props.label
                }
            }
        });

    }, [])

    React.useEffect(() => {
        chartRef.current?.update();
    }, [props.data])

    return <div className={'c-rstats__chart'}>

        <Chart
            type={'bar'}
            ref={chartRef}
            data={props.data}
            options={props.options}
        />

    </div>;
}

